import React from "react";
import { formatDate, DAY_DD_MMM_YYYY, HH_MM } from "src/utils/dateUtils";
import { Slot } from "src/containers/event/event.types";
import { map, sortBy } from "lodash-es";
import { Button } from "@ic-anywhere/ic-components";

interface SlotSelectionSummaryProps {
  slots: Slot[];
  onRemove: (slot: Slot) => void;
}

export const SlotSelectionSummary: React.FC<SlotSelectionSummaryProps> = ({ slots, onRemove }) => {
  const sortedSlots = sortBy(slots, (slot) => new Date(slot.startDate).getTime());

  return (
    <div className="d-flex flex-column gap-3">
      <h4 className="mt-2">Selection summary</h4>
      {map(sortedSlots, (slot) => (
        <div key={slot.id} className="d-flex justify-content-between align-items-center p-3 bg-lvl1">
          <div className="d-flex flex-column">
            <span className="fs-14 fw-semibold">{formatDate(slot.startDate, DAY_DD_MMM_YYYY)}</span>
            <span className="fs-14 fw-medium text-secondary">
              {formatDate(slot.startDate, HH_MM)} - {formatDate(slot.endDate, HH_MM)}
            </span>
            <span className="fs-14 text-secondary">{slot.type}</span>
          </div>
          <Button
            btnType="flat"
            color="secondary"
            style={{ width: "32px", height: "32px" }}
            onClick={(): void => onRemove(slot)}
          >
            <span className="icon">delete_outline</span>
          </Button>
        </div>
      ))}
    </div>
  );
};
